import Axios from "axios";

// export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8088/";
export const BASE_URL = "https://nin-verification-c4ac866061bb.herokuapp.com/";

export const getToken = () => localStorage.getItem("token");

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const saveAuth = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

const getHeaders = () => {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = token.startsWith("Bearer ")
      ? token
      : `Bearer ${token}`;
  }
  return headers;
};

// Generic POST
export const postData = async (route, data) => {
  const url = route.startsWith("http")
    ? route
    : `${BASE_URL}${route.replace(/^\//, "")}`;
  try {
    const response = await Axios.post(url, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Request failed";
    throw new Error(errorMsg);
  }
};

// Generic GET
export const getData = async (route) => {
  const url = route.startsWith("http")
    ? route
    : `${BASE_URL}${route.replace(/^\//, "")}`;
  try {
    const response = await Axios.get(url, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Request failed";
    throw new Error(errorMsg);
  }
};

// Generic PUT
export const putData = async (route, data) => {
  const url = route.startsWith("http")
    ? route
    : `${BASE_URL}${route.replace(/^\//, "")}`;
  try {
    const response = await Axios.put(url, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Request failed";
    throw new Error(errorMsg);
  }
};

// Generic DELETE
export const deleteData = async (route) => {
  const url = route.startsWith("http")
    ? route
    : `${BASE_URL}${route.replace(/^\//, "")}`;
  try {
    const response = await Axios.delete(url, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Request failed";
    throw new Error(errorMsg);
  }
};

// Application Specific API Helpers
export const verifyNIN = (payload) => postData("api/nin/verify", payload);
export const getAllNINRecords = () => getData("api/nin/all");
export const loginApi = (credentials) =>
  postData("api/auth/login", credentials);
export const createUserApi = (userData) =>
  postData("api/auth/create-user", userData);
export const getAllUsersApi = () => getData("api/auth/allUsers");
export const updateUserStatusApi = (id, active) =>
  putData(`api/auth/user/${id}/status`, { active });
export const deleteUserApi = (id) => deleteData(`api/auth/user/${id}`);
